// @flow
import React from 'react';
import DropdownLabel from '@tectonics/look-and-feel/volcanes/molecules/dropdown/dropdown-label';
import DropdownSelect from '@tectonics/look-and-feel/volcanes/molecules/dropdown/dropdown-select';
import DropdownButton from '@tectonics/look-and-feel/volcanes/molecules/dropdown/dropdown-button';
import DropdownItem from '@tectonics/look-and-feel/volcanes/molecules/dropdown/dropdown-item';
import styled from 'styled-components';
import type {DropdownOption} from '@tectonics/look-and-feel/volcanes/molecules/dropdown/dropdown-option';
import type {Cryptocurrency} from '@tectonics/commons/cryptocurrency/cryptocurrencies/cryptocurrency-type';
import { useTranslation } from 'react-i18next';

type Props = {
  allowedCryptocurrenciesTypes: Array<Cryptocurrency>,
  selectedCryptocurrencyOption: DropdownOption,
  cryptocurrencyIsOpen: boolean,
  setCryptocurrencyIsOpen: (boolean) => void,
  submitting: boolean,
  onCryptocurrencySelect: (cryptocurrency: Cryptocurrency) => void,
};

const CryptocurrencyDropdown = ({
  allowedCryptocurrenciesTypes,
  selectedCryptocurrencyOption,
  cryptocurrencyIsOpen,
  setCryptocurrencyIsOpen,
  submitting,
  onCryptocurrencySelect,
}: Props) => {
  const { t } = useTranslation('payment-methods/cryptocurrency');

  return (
    <>
      <DropdownLabel dataTestName="cryptocurrency">
        {t('cryptocurrencyLabel')}
      </DropdownLabel>
      <DropdownSelect
        dataTestName="cryptocurrency"
        setIsOpen={setCryptocurrencyIsOpen}
      >
        <InvisibleInputForTests
          type="select"
          id="cryptocurrency_dropdown"
          name="cryptocurrency_dropdown"
          value="cryptocurrency_dropdown"
          readOnly
        />
        <DropdownButton
          selectedOption={selectedCryptocurrencyOption}
          isOpen={cryptocurrencyIsOpen}
          defaultText={t('cryptocurrencySelectPlaceholder')}
          setIsOpen={setCryptocurrencyIsOpen}
          disabled={submitting}
        />
        <DropdownList isOpen={cryptocurrencyIsOpen}>
          {allowedCryptocurrenciesTypes.map(cryptocurrency =>
            <DropdownItem
              key={cryptocurrency.code}
              disabled={submitting}
              dataTestName="cryptocurrency"
              option={{
                value: cryptocurrency.code,
                text: cryptocurrency.name,
                icon: cryptocurrency.icon,
              }}
              handleClick={() => onCryptocurrencySelect(cryptocurrency)}
            />)
          }
        </DropdownList>
      </DropdownSelect>
    </>
  );
};

const DropdownList = styled.ul`
  position: absolute;
  width: 100%;
  background-color: #ffffff;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);
  z-index: 10;
  overflow: hidden;
  transform: scaleY(${props => (props.isOpen ? 1 : 0)});
  transform-origin: top;
  opacity: ${props => (props.isOpen ? 1 : 0)};
  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;
`;

const InvisibleInputForTests = styled.input`
    display: none;
`;

export default CryptocurrencyDropdown;
